import * as core from '../../../../../../../core'
import * as changeImpactValidationStatus from '../change-impact-validation-status'

export const RESOURCE = {
  payload: {
    description: 'Completed',
    enumId: core.dms.models.Enum.Id.from({
      partialId: changeImpactValidationStatus.RESOURCE.payload.partialId,
    }),
    id: 'Completed',
    name: 'Completed',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
